module.exports = __webpack_public_path__ + "img/icon-add.72821acb.svg";